export default "__VITE_ASSET__1dccf732__"